import React, { useState } from "react";
import I18n from "i18n";
import axios from "axios";

interface props {
  isPdfWithoutBranding: boolean;
}

export function GeneralSettingsView({ isPdfWithoutBranding }: props) {
  const [pdfWithoutBranding, setPdfWithoutBrandingState] =
    useState<boolean>(isPdfWithoutBranding);

  async function togglePdfBranding() {
    // optimistic update
    setPdfWithoutBrandingState(!pdfWithoutBranding);

    const url = "/api/v3/pdf_settings";

    try {
      await axios.put(url, { pdf_without_branding: !pdfWithoutBranding });
    } catch (err) {
      // revert on error
      setPdfWithoutBrandingState(!!pdfWithoutBranding);
      console.error("Failed to update PDF branding setting", err);
    }
  }

  return (
    <div className="lightened-container lifted-container pal">
      <div className="mbl">
        <h1 className="heading-xxlarge">
          {I18n.t("webapp.settings.sidebar.general")}
        </h1>
      </div>

      <form>
        <h4 className="heading-medium mvs">
          {I18n.t("webapp.settings.general.pdf_branding_subHeading")}
        </h4>

        <div className="button-group button-group--checkbox button-group--vertical mbl">
          <button
            type="button"
            className={
              pdfWithoutBranding
                ? "button-group__item is-active"
                : "button-group__item"
            }
            onClick={() => {
              togglePdfBranding();
            }}
          >
            {I18n.t("webapp.settings.general.pdf_branding_include")}
          </button>
        </div>
      </form>
    </div>
  );
}
